import WorkSlider from "./ourworkslider.js";
export default function OurWork()
{

const title="Our Work";

    return(
        <section className="section-1 pb-[40px] overflow-x-hidden">
            <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
                <div className="text-center">
                    <h1 className='lg:text-[55px]  text-[35px]  mb-0 font-bold text-[#262626] relative inline-block'>{title} <span className=" rounded-[20px] w-[80px] m-auto h-[5px] bg-[#FB802C] block"></span></h1>
                </div>
            </div>
            <div className="relative overflow-hidden my-[50px]"
           ><WorkSlider/></div>
        </section>
    )
}